<template>
  <!-- 倒计时 -->
  <div class="countdown-container">
    <div class="counter-item">
      <div class="front"></div>
      <div class="digit" :class="'digit' + h1"></div>
    </div>
    <div class="counter-item">
      <div class="front"></div>
      <div class="digit" :class="'digit' + h2"></div>
    </div>
    <div class="counter-item">
      <div class="front"></div>
      <div class="digit digit_colon"></div>
    </div>
    <div class="counter-item">
      <div class="front"></div>
      <div class="digit" :class="'digit' + m1"></div>
    </div>
    <div class="counter-item">
      <div class="front"></div>
      <div class="digit" :class="'digit' + m2"></div>
    </div>
    <div class="counter-item">
      <div class="front"></div>
      <div class="digit digit_colon"></div>
    </div>
    <div class="counter-item">
      <div class="front"></div>
      <div class="digit" :class="'digit' + s1"></div>
    </div>
    <div class="counter-item">
      <div class="front"></div>
      <div class="digit" :class="'digit' + s2"></div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    time: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      countTime: 0,
      timer: null
    };
  },
  computed: {
    //   时-十位
    h1() {
      let h = Math.floor((this.time / (1000 * 60 * 60)) % 24);
      if (h > 9) {
        return parseInt(h / 10);
      } else {
        return 0;
      }
    },
    //   时-个位
    h2() {
      let h = Math.floor((this.time / (1000 * 60 * 60)) % 24);
      return h % 10;
    },
    //   分-十位
    m1() {
      let m = Math.floor((this.time / (1000 * 60)) % 60);
      if (m > 9) {
        return parseInt(m / 10);
      } else {
        return 0;
      }
    },
    //   分-个位
    m2() {
      let m = Math.floor((this.time / (1000 * 60)) % 60);
      return m % 10;
    },
    //   秒-十位
    s1() {
      let s = Math.floor((this.time / 1000) % 60);
      if (s > 9) {
        return parseInt(s / 10);
      } else {
        return 0;
      }
    },
    //   秒-个位
    s2() {
      let s = Math.floor((this.time / 1000) % 60);
      return s % 10;
    }
  },
  created() {
    // this.start();
  },
  methods: {
    //开始计时
    start() {
      this.countTime = this.time;
      this.timer = setInterval(() => {
        if (this.countTime > 1000) {
          this.countTime -= 1000;
        } else {
          this.destroy();
        }
      }, 1000);
    },
    //销毁计时
    destroy() {
      clearInterval(this.timer);
    }
  }
};
</script>


// WEBPACK FOOTER //
// src/components/Countdown/index.vue